import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateHeaderHeight } from '@core/js/components/system/App/store/actions';
import { useResizeObserver } from '@core/js/hooks/useResizeObserver';

// sun the method for determining the height has been changed(22 line)
export const useUpdateHeaderHeight = () => {
    const dispatch = useDispatch();
    const [offsetHeight, setOffsetHeight] = useState(0);

    useEffect(() => {
        dispatch(updateHeaderHeight({ height: offsetHeight }));

        return () => {
            dispatch(updateHeaderHeight({ height: offsetHeight, decrement: true }));
        };
    }, [offsetHeight, dispatch]);

    return useResizeObserver({
        callback: useCallback((entries) => {
            setOffsetHeight(entries[0].target.getBoundingClientRect().height);
        }, [])
    });
};
